

export const axeptaUser = {

    //tests
 /* merchantID : 'BNP_MOUTCHICLOISIRS_ECOM_t', 
blowfishPassword : 'Ax8]*6Fo4n)CwT9[',   
hmacPassword : "Eb8_6[jANg3!*Zc2r5H?Cf=4]W7q9zK(" , */   

//test BNP
 /* merchantID : 'BNP_DEMO_AXEPTA', 
blowfishPassword : 'Tc5*2D_xs7B[6E?w',   
hmacPassword : "4n!BmF3_?9oJ2Q*z(iD7q6[RSb5)a]A8", */   



merchantID :"BNP_MOUTCHICLOISIRS_ECOM",
blowfishPassword : "tJ_2[c6RE!x8=3Dj",
hmacPassword : "f?4T8jX[C=p9(7Gb2r!SzL5_]6kJaE3)",

}; 



